import { throwError } from "@/lib/throwError";
import { del, get, post, put } from "@/services/axiosUitils";
import {
  EmailConfiguration,
  EmailConfigurationList,
  EmailConfigurationPayload,
} from "@/utils/types/emailConfiguration";

const basePath = "/api/tenant-core/tenant-email-config";

class EmailConfigurationService {
  getAllEmailConfigurations = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }): Promise<EmailConfigurationList> => {
    return await get<EmailConfigurationList>(`${basePath}/`, {
      params: {
        page,
        page_size: pageSize,
      },
    });
  };

  getEmailConfigurationById = async (
    id: string
  ): Promise<EmailConfiguration> => {
    if (!id) {
      throwError("ID is required", "EmailConfigurationService");
    }
    return await get<EmailConfiguration>(`${basePath}/${id}/`);
  };

  createEmailConfiguration = async (
    payload: EmailConfigurationPayload
  ): Promise<any> => {
    if (!payload) {
      throwError("Payload is required", "EmailConfigurationService");
    }
    return await post(`${basePath}/`, payload);
  };

  updateEmailConfiguration = async (
    id: string,
    payload: EmailConfigurationPayload
  ): Promise<any> => {
    if (!id || !payload) {
      throwError("ID and payload are required", "EmailConfigurationService");
    }
    return await put(`${basePath}/${id}/`, payload);
  };

  deleteEmailConfiguration = async (id: string): Promise<any> => {
    if (!id) {
      throwError("ID is required", "EmailConfigurationService");
    }
    return await del(`${basePath}/${id}/`);
  };
}

const instance = new EmailConfigurationService();
export default instance;
